import { api } from './client';

type Envelope<T> = { data: T };

export type ApiKeyListItem = {
  id: string;
  name: string;
  prefix: string;
  createdAt: string;
  lastUsedAt: string | null;
  lastUsedIp: string | null;
  revoked: boolean;
  expiresAt: string | null;
};

export type ApiKeyCreated = {
  id: string;
  name: string;
  prefix: string;
  rawToken: string;
  createdAt: string;
};

export const apiKeysApi = {
  async list(): Promise<ApiKeyListItem[]> {
    const { data } = await api.get<Envelope<ApiKeyListItem[]>>('/api-keys');
    return data.data;
  },

  async create(input: { name: string; expiresAt?: string }): Promise<ApiKeyCreated> {
    const { data } = await api.post<Envelope<ApiKeyCreated>>('/api-keys', input);
    return data.data;
  },

  async revoke(uuid: string): Promise<void> {
    await api.delete(`/api-keys/${uuid}`);
  },
};
